import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface IPaymentCardPresenceCellProps {
  posCardPresence?: string;
}

export function PaymentCardPresenceCell({ posCardPresence }: IPaymentCardPresenceCellProps) {
  const { t } = useTranslation();

  const getLabel = useCallback(() => {
    if (!posCardPresence) return '/';
    if (posCardPresence === '0') return t('components.molecules.forms.no');
    if (posCardPresence === '1') return t('components.molecules.forms.yes');

    return t('pages.currentProfiles.cards.transactions.table.headers.cardHolderPresence.9');
  }, [t, posCardPresence]);

  return <span className="typo-body-regular-paragraph text-secondary">{getLabel()}</span>;
}
